import {
  Button,
  styled,
} from '@mui/material';
import { closeSnackbar, SnackbarKey } from 'notistack';

const StyledButton = styled(Button)({
  '&#activity-button': {
    width: 'unset',
    shrink: 0,
    display: 'flex',
    padding: 8,
    textTransform: 'none',
  },
});

export default function renderActivityChangeAction(cancel: () => void, titleButton: string) {
  function render(snackbarId: SnackbarKey) {
    return (
      <StyledButton
        id="activity-button"
        variant="outlined"
        onClick={() => {
          cancel();
          closeSnackbar(snackbarId);
        }}
      >
        {titleButton}
      </StyledButton>
    );
  }
  return render;
}
